module.exports = __webpack_public_path__ + "img/meatballs-menu.64aa7f8e.svg";